import { FirebaseAuthErrorCode } from '@griply/types';
import { AuthError, confirmPasswordReset } from 'firebase/auth';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';

import { getAuthentication } from './helpers';

// Expired and already-used are one thing to the user: this link is dead, request
// a new one. Neither is a bug, so neither is reported.
const DEAD_LINK_CODES: string[] = [
  FirebaseAuthErrorCode.InvalidActionCode,
  FirebaseAuthErrorCode.ExpiredActionCode,
];

export const resetPassword = async (code: string, password: string) => {
  const auth = await getAuthentication();

  try {
    await confirmPasswordReset(auth, code, password);
  } catch (e) {
    const errorCode = (e as AuthError).code ?? '';

    if (DEAD_LINK_CODES.includes(errorCode)) {
      throw ResetPasswordErrorTypes.InvalidCode;
    }

    // The form has no strength check of its own, so a too-weak password lands
    // here — the user's to retype, not ours to hear about.
    if (errorCode === FirebaseAuthErrorCode.WeakPassword) {
      throw ResetPasswordErrorTypes.WeakPassword;
    }

    getErrorReporter().captureException(e, {
      tags: { source: 'firebase-reset-password' },
    });
    throw ResetPasswordErrorTypes.Unknown;
  }
};
